// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__wyFyE","DesktopOnly":"Toolbar_DesktopOnly__QdikG"};